import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter  } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { LanguageService } from 'src/app/service/language-service/language.service';

@Component({
  selector: 'app-video-recorder',
  templateUrl: './video-recorder.component.html',
  styleUrls: ['./video-recorder.component.scss'],
})
export class VideoRecorderComponent  implements OnInit {

 @ViewChild('videoElement') videoElement!: ElementRef<HTMLVideoElement>;
  language:string = "es";
  translations;

  private mediaRecorder!: MediaRecorder;
  private recordedChunks: Blob[] = [];
  private countdownTimer: any;
  isRecording = false;
  cameraReady = false;
  countdown = 0;
  maxTime = 20;
  @Output() blobRecorded: EventEmitter<any> = new EventEmitter<any>();
  @Output() errorBlobRecorded: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private alertCtrl: AlertController,
    private languageService: LanguageService,

  ) {}

  ngOnInit() {
    this.subLanguageConfig();
    this.initCamera();
  }

  subLanguageConfig() {
    this.languageService.getCurrentLang().subscribe(lang => {
      this.language = lang;
      this.languageService.getGlobalTranslateFile(this.language).subscribe(
        {
          next: (data) => {
          this.translations = data;
          // console.log("translations ch::", this.translations)
          },
          error: (e) => {
            console.log(e);
          }
        }
      );
    });
  }

  async initCamera() {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: true,
        audio: true
      });

      this.videoElement.nativeElement.srcObject = stream;
      this.cameraReady = true;

      this.mediaRecorder = new MediaRecorder(stream, { mimeType: 'video/webm' });
      this.mediaRecorder.ondataavailable = (event) => {
        if (event.data.size > 0) {
          this.recordedChunks.push(event.data);
        }
      };

      this.mediaRecorder.onstop = () => {
        const videoBlob = new Blob(this.recordedChunks, { type: 'video/webm' });
        const uniqueFileName = `video_${Date.now()}.webm`;
          // this.sendToServer(videoBlob);
          this.blobRecorded.emit( {video: videoBlob, fileName: uniqueFileName });
          // resolve(videoBlob);
          // Detener la cámara
          stream.getTracks().forEach(track => track.stop());
      };

    } catch (error) {
      console.error('Error accediendo a la cámara:', error);
      this.errorBlobRecorded.emit()
      this.showAlert(null, this.translations?.GLOBAL.PERMISO_VIDEO, false);
    }
  }

  startRecording() {
    if (!this.cameraReady) return;

    this.recordedChunks = [];
    this.isRecording = true;
    this.countdown = 0;

    this.mediaRecorder.start();

    this.countdownTimer = setInterval(() => {
      this.countdown++;
      if (this.countdown >= this.maxTime) {
        this.stopRecording();
      }
    }, 1000);
  }

  stopRecording() {
    if (!this.isRecording) return;

    clearInterval(this.countdownTimer);
    this.mediaRecorder.stop();
    this.isRecording = false;
  }

  sendToServer(videoBlob: Blob) {
    const formData = new FormData();
    formData.append('video', videoBlob, 'recording.webm');

    // this.http.post('TU_API_ENDPOINT_AQUI', formData).subscribe({
    //   next: (response) => {
    //     console.log('Video enviado exitosamente:', response);
    //   },
    //   error: (error) => {
    //     console.error('Error enviando video:', error);
    //   }
    // });
  }

  async showAlert(title?: string, message?: string, redirect:boolean = true) {
		let alert = await this.alertCtrl.create({
			header: title ? title : "",
			message: message,
			mode: "ios",
			buttons:  [
						{
							text: this.languageService.acceptTranslate(this.language),
							handler: () => {
                this.alertCtrl.dismiss();
							},
						},
				  ],
		});
		await alert.present();
	}

  closeRecorder() {
    this.errorBlobRecorded.emit()
  }

  ngOnDestroy() {
    // const stream = this.videoElement?.nativeElement?.srcObject as MediaStream;
    // if (stream) {
    //   stream.getTracks().forEach(track => track.stop());
    // }
  }

}
